
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import DialogModal from '../utils/DialogModal';


export interface StopSharingDialogProps {
  open: boolean;
  onClose: (value?: string) => void;
  remoteParticipantName: string;
}

const StopSharingDialog = (props: StopSharingDialogProps) => {

  const { open, onClose, ...other } = props;

  return (
    <DialogModal open={open} onClose={onClose} iconClass={"screen-exclam"} buttonCancel={"CANCEL"} buttonOk={"CONTINUE"}>
      <>
          <div className='bold'>Screen Share Conflict</div>

          <div className='tips'><big><b>{props.remoteParticipantName}</b></big> is currently sharing its screen, are you sure you want to replace it with yours ?</div>

      </>
    </DialogModal>
  )
}

export default StopSharingDialog;
